import React from "react";
import owSvg from "../assets/images/ow.svg";
import etSvg from "../assets/images/et.svg";
import gdSvg from "../assets/images/gd.svg";

const testimonies = [
  {
    img : owSvg,
    alt : "Oprah Winfrey",
    quote:
      '“Geneen Roth’s book Women, Food, and God changed how I see my relationship with food. It blows the doors off.”',
    name: "- Oprah Winfrey",
    circle: false,
  },
  {
    img : etSvg,
    alt : "Eckhart Tolle",
    quote:
      '“Praises Roth’s approach for helping people find peace and presence in everyday life.”',
    name: "- Eckhart Tolle",
    circle: false,
  },
  {
    img : gdSvg,
    alt : "Glennon Doyle",
    quote:
      '“Geneen Roth’s book Women, Food, and God changed how I see my relationship with food. It blows the doors off.”',
    name: "- Glennon Doyle, author of Untamed",
    circle: false,
  },
];

export default function MoreAbout() {
  return (
    <section className="px-4 sm:px-[10%] bg-white py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-century text-left">
        More About Geneen
      </h2>
      <p className="mt-3 text-base sm:text-lg font-roboto text-left">
        Geneen Roth is a <span className="italic">New York Times</span>{" "}
        bestselling author and pioneer in linking compulsive eating with deeper
        personal and spiritual issues. Over her 40-year career, she has
        transformed the lives of thousands through her books, workshops, and
        retreats, earning praise from influential figures like Eckhart Tolle,
        Oprah Winfrey and Glennon Doyle.
      </p>
      <div className="flex flex-wrap justify-center gap-6 mt-6">
        {testimonies.map(({ img, alt, quote, name, circle }) => (
          <article
            key={name}
            className="flex flex-col items-center w-full sm:w-1/2 lg:w-1/4 px-2"
          >
            <div
              className={`${
                circle
                  ? "rounded-full ring-[7px] sm:ring-[7px] lg:ring-[10px] ring-[#9AEEDA] mt-[10px] w-[180px] h-[180px] sm:w-[220px] sm:h-[220px] lg:w-[265px] lg:h-[265px]"
                  : "w-48 h-48 sm:w-56 sm:h-56 lg:w-72 lg:h-72"
              }`}
            >
              <img
                src={img}
                alt={alt}
                className={`object-cover rounded-full ${
                  circle
                    ? "w-[180px] h-[180px] sm:w-[220px] sm:h-[220px] lg:w-[265px] lg:h-[265px]"
                    : "w-full h-full"
                }`}
              />
            </div>
            <div className="mt-4 px-2 sm:px-4 flex flex-col gap-2">
              <p className="text-base sm:text-[17px] font-roboto text-left">
                {quote}
              </p>
              <p className="text-base sm:text-[17px] font-roboto font-semibold text-left">
                {name}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}